import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { topics } from "@/mocks/topics";
import { getDramaTitle } from "@/utils/content";
import type { Topic } from "@/types/content";

const items = topics as Topic[];

export default function TopicSection() {
  return (
    <section className="bg-background-200/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <SectionHeading
          eyebrow="编辑精选"
          title="热门推荐专题"
          description="我们定期为你策划影视专题合集，按主题快速找到想看的那一类。"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {items.map((topic) => (
            <article
              key={topic.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={topic.cover}
                  alt={topic.title}
                  title={topic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-foreground-950/70 px-3 py-1 text-xs text-white backdrop-blur-sm">
                  <i className="ri-bookmark-3-line text-accent-400"></i>
                  专题
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{topic.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{topic.description}</p>
                <p className="mt-3 flex items-start gap-1.5 text-sm text-accent-700">
                  <i className="ri-lightbulb-line mt-0.5"></i>
                  <span>推荐理由：{topic.reason}</span>
                </p>
                <div className="mt-auto pt-4 flex flex-wrap gap-2">
                  {topic.dramaIds.map((id) => (
                    <Link
                      key={id}
                      to={`/detail/${id}`}
                      className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900 hover:bg-accent-100 hover:text-accent-900 transition-colors"
                    >
                      <i className="ri-play-circle-line"></i>
                      {getDramaTitle(id)}
                    </Link>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}